<template>
<div class="chapter">
<div class="inner_page">
<section>
<p class="toc-title">Table of Contents</p>
<p class="toc"><a href="#/xhtml/introduction">INTRODUCTION</a></p>
<p class="toc"><a href="#/xhtml/chapter01">DOWN IN THE DITCH: JOANNA DENNEHY, SERIAL STABBER</a></p>
<p class="toc1"><a href="#/xhtml/chapter01">Charlotte Platt</a></p>
<p class="toc"><span href="#/xhtml/chapter02" title="Link target outside of Sample">RUTH SNYDER: THE ORIGINAL <em class="italic">FEMME FATALE</em></span></p>
<p class="toc1"><span href="#/xhtml/chapter02" title="Link target outside of Sample">Ciaran Conliffe</span></p>
<p class="toc"><span href="#/xhtml/chapter03" title="Link target outside of Sample">INNOCENCE TAKEN: THE MURDER OF KARISSA BOUDREAU</span></p>
<p class="toc1"><span href="#/xhtml/chapter03" title="Link target outside of Sample">Mike Browne</span></p>
<p class="toc"><span href="#/xhtml/chapter04" title="Link target outside of Sample">MAHIN: MONSTER OR VICTIM?</span></p>
<p class="toc1"><span href="#/xhtml/chapter04" title="Link target outside of Sample">Mitzi Szereto</span></p>
<p class="toc"><span href="#/xhtml/chapter05" title="Link target outside of Sample">TWISTED FIRESTARTER</span></p>
<p class="toc1"><span href="#/xhtml/chapter05" title="Link target outside of Sample">C L Raven</span></p>
<p class="toc"><span href="#/xhtml/chapter06" title="Link target outside of Sample">ON THE COURTHOUSE STEPS: THE TRIAL OF SUSAN SMITH</span></p>
<p class="toc1"><span href="#/xhtml/chapter06" title="Link target outside of Sample">Cathy Pickens</span></p>
<p class="toc"><span href="#/xhtml/chapter07" title="Link target outside of Sample">ANGELINA NAPOLITANO: “I AM NOT A BAD WOMAN”</span></p>
<p class="toc1"><span href="#/xhtml/chapter07" title="Link target outside of Sample">Edward Butts</span></p>
<p class="toc"><span href="#/xhtml/chapter08" title="Link target outside of Sample">THE STRANGE CASE OF KELI LANE</span></p>
<p class="toc1"><span href="#/xhtml/chapter08" title="Link target outside of Sample">Anthony Ferguson</span></p>
<p class="toc"><span href="#/xhtml/chapter09" title="Link target outside of Sample">JOLLY JOSEPH: THE KERALA CYANIDE SERIAL KILLER</span></p>
<p class="toc1"><span href="#/xhtml/chapter09" title="Link target outside of Sample">Shashi Kadapa</span></p>
<p class="toc"><span href="#/xhtml/chapter10" title="Link target outside of Sample">WOMEN FIGHT BACK</span></p>
<p class="toc1"><span href="#/xhtml/chapter10" title="Link target outside of Sample">Tom Larsen</span></p>
<p class="toc"><span href="#/xhtml/chapter11" title="Link target outside of Sample">BEAUTY AND BEAST</span></p>
<p class="toc1"><span href="#/xhtml/chapter11" title="Link target outside of Sample">Ily Goyanes</span></p>
<p class="toc"><span href="#/xhtml/chapter12" title="Link target outside of Sample"><em class="italic">ANNO BISESTO, ANNO FUNESTO</em></span></p>
<p class="toc1"><span href="#/xhtml/chapter12" title="Link target outside of Sample">Alisha Holland</span></p>
<p class="toc"><span href="#/xhtml/chapter13" title="Link target outside of Sample">DEAD WOMAN WALKING</span></p>
<p class="toc1"><span href="#/xhtml/chapter13" title="Link target outside of Sample">Joan Renner</span></p>
<p class="toc"><span href="#/xhtml/chapter14" title="Link target outside of Sample">MONA FANDEY: THE MALAYSIAN MURDERER</span></p>
<p class="toc1"><span href="#/xhtml/chapter14" title="Link target outside of Sample">Chang Shih Yen</span></p>
<p class="toc"><span href="#/xhtml/aboutauthor" title="Link target outside of Sample">ABOUT THE EDITOR</span></p>
<p class="toc"><span href="#/xhtml/bm" title="Link target outside of Sample">ABOUT THE CONTRIBUTORS</span></p>
<p class="image"><img alt="image" src="images/pg12_1.jpg"/></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?07427e2a